var _path, _path2, _path3, _path4, _circle, _circle2, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 71,
    viewBox: "0 0 141 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.1977 29.3193H89.6781C92.6753 29.329 95.5472 30.6484 97.6666 32.9895C99.7859 35.3306 100.98 38.5031 100.989 41.8139V50.1406C100.98 53.4514 99.7859 56.6238 97.6666 58.9649C95.5472 61.306 92.6753 62.6255 89.6781 62.6352H16.1977L4.88672 70.0407V41.7683C4.90414 38.4647 6.10273 35.3025 8.22137 32.9707C10.34 30.6389 13.207 29.3265 16.1977 29.3193Z",
    fill: "url(#paint0_linear_3455_119163)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.311 24.4326H84.7914C87.7885 24.4422 90.6605 25.7617 92.7798 28.1028C94.8992 30.4439 96.0937 33.6164 96.1024 36.9272V45.2539C96.0937 48.5647 94.8992 51.7371 92.7798 54.0782C90.6605 56.4193 87.7885 57.7388 84.7914 57.7484H11.311L0 65.154V36.8816C0.017419 33.578 1.21601 30.4158 3.33465 28.084C5.45329 25.7522 8.32029 24.4398 11.311 24.4326Z",
    fill: "url(#paint1_linear_3455_119163)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.649 20.4082C115.649 20.5551 115.621 20.6989 115.567 20.8394C115.519 20.9799 115.447 21.0981 115.352 21.1939L110.055 27.7189H115.475V29.319H107.504V28.4567C107.504 28.3609 107.528 28.2459 107.576 28.1118C107.624 27.9776 107.696 27.8499 107.791 27.7285L113.129 21.146H107.812V19.5459H115.649V20.4082Z",
    fill: "#A7A7A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.082 1.86839C140.082 2.18671 140.027 2.49811 139.918 2.80259C139.822 3.10707 139.679 3.36311 139.487 3.5707L128.895 17.7082H139.733V21.1751H123.793V19.3067C123.793 19.0991 123.841 18.85 123.936 18.5594C124.032 18.2687 124.175 17.9919 124.367 17.729L135.041 3.4669H124.408V0H140.082V1.86839Z",
    fill: "#A7A7A7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.44328,
    cy: 2.44328,
    r: 2.44328,
    transform: "matrix(1 0 0 -1 27.6904 45.6084)",
    fill: "url(#paint2_radial_3455_119163)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.44328,
    cy: 2.44328,
    r: 2.44328,
    transform: "matrix(1 0 0 -1 45.6079 45.6084)",
    fill: "url(#paint3_radial_3455_119163)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.44328,
    cy: 2.44328,
    rx: 2.44328,
    ry: 2.44328,
    transform: "matrix(1 0 0 -1 63.5254 45.6084)",
    fill: "url(#paint4_radial_3455_119163)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3455_119163",
    x1: 94.1526,
    y1: 29.3193,
    x2: 4.88672,
    y2: 29.3193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884252,
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3455_119163",
    x1: 0,
    y1: 24.4326,
    x2: 99.4262,
    y2: 24.4326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972742,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3455_119163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.44328 2.44328) rotate(90) scale(4.07214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3455_119163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.44328 2.44328) rotate(90) scale(4.07214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3455_119163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.44328 2.44328) rotate(90) scale(4.07214 4.07214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotification);
export default __webpack_public_path__ + "static/media/empty-notification.4dad1788474ab6fbd1faee771ee80775.svg";
export { ForwardRef as ReactComponent };